<template>
  <div class="roles-tooltip">
    <v-menu
      v-if="roles.length"
      open-on-hover
      open-delay="200"
      location="top left"
    >
      <template #activator="{ props }">
        <v-icon
          color="iconDefault"
          class="info-icon ml-2"
          size="16px"
          icon="$information-outline"
          v-bind="props"
        />
      </template>
      <v-list
        class="roles-list"
        density="compact"
      >
        <v-list-item
          v-for="(role, index) in roles"
          :key="index"
          class="menu-list-item text-left"
        >
          <p>{{ role }}</p>
        </v-list-item>
        <v-divider />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'RolesTooltip',
  props: {
    roles: { type: Array, default: () => [] },
  },
};
</script>
<style  lang="less" scoped>
@import '@/less/mixins';
.v-menu__content {
  .shadow();
  border-radius: 10px;
}
.roles-tooltip {
  display: flex;
  .roles-list {
    max-height: 352px;
    overflow: auto;
    .menu-list-item.v-list-item {
      border-bottom: 1px solid @stroke-default;
      min-height: 40px;
      height: 40px;
    }
  }
}
</style>
